import signedFetch from '../util/signedFetch.js';

/**
 * GetInvitedUserDetails API call helper. This uses a token to find a partially registered user.
 * For latest param spec see: get-invited-user-details-request-body.json
 *  - userToken: String - The token to look for.
 */
export default body => signedFetch('getInvitedUserDetails', `${__API_BASE__}/open/user/invited`, 'POST', body);
